import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "modal-title fs-5",
    id: "exerciseFiltersModalLabel"
  }, "Filters"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  id: "ExFiltersForm",
  ref: "filtersForm"
}
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "academicProgramField",
  class: "form-label"
}, " Profil: ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Oricare", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "gradeField",
  class: "form-label"
}, " Clasa: ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Oricare", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "chapterField",
  class: "form-label"
}, " Capitol: ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Oricare", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "subchapterField",
  class: "form-label"
}, " Subcapitol: ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Oricare", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "statementContainsField",
  class: "form-label mt-4"
}, " Enunțul conține: ", -1)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "publishingContainsField",
  class: "form-label mt-4"
}, " Editura conține: ", -1)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "isCompleteStatusField",
  class: "form-label mt-4"
}, " Status: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Any", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", null, "Complete", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", null, "In work", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "minDifficultyLevelField",
  class: "form-label mt-4"
}, " Nivel minim de dificultate ", -1)
const _hoisted_35 = { class: "form-text text-muted" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  for: "maxDifficultyLevelField",
  class: "form-label mt-4"
}, " Nivel maxim de dificultate ", -1)
const _hoisted_38 = { class: "form-text text-muted" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "examTypeField",
  class: "form-label mt-4"
}, " Tip examen ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Oricare", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  id: "academicProgramField",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exerciseFiltersData.academicProgramId) = $event))
                }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.academicPrograms, (academicProgram, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: academicProgram.id
                    }, _toDisplayString(academicProgram.name), 9, _hoisted_10))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.exerciseFiltersData.academicProgramId]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  id: "gradeField",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exerciseFiltersData.gradeId) = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.chaptersRefresh && _ctx.chaptersRefresh(...args)))
                }, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grades, (grade, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: grade.id
                    }, _toDisplayString(grade.name), 9, _hoisted_14))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.exerciseFiltersData.gradeId]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("select", {
                  id: "chapterField",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.exerciseFiltersData.chapterId) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.subchaptersRefresh && _ctx.subchaptersRefresh(...args)))
                }, [
                  _hoisted_17,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: chapter.id
                    }, _toDisplayString(chapter.name), 9, _hoisted_18))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.exerciseFiltersData.chapterId]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  id: "subchapterField",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.exerciseFiltersData.subchapterId) = $event))
                }, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subchapters, (subchapter, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: subchapter.id
                    }, _toDisplayString(subchapter.name), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.exerciseFiltersData.subchapterId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                id: "statementContainsField",
                type: "text",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.exerciseFiltersData.statementContains) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exerciseFiltersData.statementContains]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                id: "publishingContainsField",
                type: "text",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.exerciseFiltersData.publishingContains) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exerciseFiltersData.publishingContains]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("select", {
                id: "isCompleteStatusField",
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exerciseFiltersData.isCompleteStatus) = $event))
              }, _hoisted_32, 512), [
                [_vModelSelect, _ctx.exerciseFiltersData.isCompleteStatus]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                id: "minDifficultyLevelField",
                type: "range",
                class: "form-range",
                step: "1",
                max: "2",
                min: "0",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.exerciseFiltersData.minDifficultyLevel) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exerciseFiltersData.minDifficultyLevel]
              ]),
              _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.difficultyLevels[
                    parseInt(_ctx.exerciseFiltersData.minDifficultyLevel)
                  ]), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                id: "maxDifficultyLevelField",
                type: "range",
                class: "form-range",
                step: "1",
                max: "2",
                min: "0",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exerciseFiltersData.maxDifficultyLevel) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exerciseFiltersData.maxDifficultyLevel]
              ]),
              _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.difficultyLevels[
                    parseInt(_ctx.exerciseFiltersData.maxDifficultyLevel)
                  ]), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("select", {
                id: "examTypeField",
                class: "form-select",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.exerciseFiltersData.examType) = $event))
              }, [
                _hoisted_41,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.examTypesMap), (examType, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: examType
                  }, _toDisplayString(_ctx.examTypesMap[examType]), 9, _hoisted_42))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.exerciseFiltersData.examType]
              ])
            ])
          ])
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
        }, " Clear filters "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          "data-bs-dismiss": "modal",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('update-filters', _ctx.exerciseFiltersData)))
        }, " Update filters ")
      ])
    ])
  ]))
}